export default function AboutSection() {
  return (
    <section id="about" className="relative py-24 bg-gradient-to-b from-slate-900 via-slate-800 to-slate-900 overflow-hidden">
      <div className="absolute inset-0 opacity-30">
        <div className="absolute top-20 left-10 w-72 h-72 bg-pink-500/20 rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-cyan-500/20 rounded-full blur-3xl"></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-6">
        <div className="mb-16 text-center">
          <div className="inline-block bg-gradient-to-r from-pink-500/20 to-cyan-500/20 rounded-full px-6 py-2 mb-4">
            <span className="text-sm font-bold text-transparent bg-clip-text bg-gradient-to-r from-pink-400 to-cyan-400">ABOUT US</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-white leading-tight mb-6">
            夢を叶える<span className="text-transparent bg-clip-text bg-gradient-to-r from-pink-400 to-cyan-400">プロダクション</span>
          </h2>
          <p className="text-lg text-gray-300 max-w-2xl mx-auto leading-relaxed">
            STELLAR LIVEは、VTuberの可能性を最大限に引き出し、世界中のファンに最高のエンタメと感動を届けることを使命としています。
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="relative">
            <div className="absolute -inset-4 bg-gradient-to-r from-pink-500/20 to-cyan-500/20 rounded-3xl blur-xl"></div>
            <img
              src="https://public.readdy.ai/ai/img_res/843ebb082babc9b67a40d2d8e35639e6.jpg"
              alt="スタジオ"
              className="relative w-full h-auto rounded-3xl shadow-2xl object-cover object-top"
            />
          </div>

          <div className="space-y-8">
            <div>
              <p className="text-7xl md:text-8xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-pink-400 to-cyan-400 mb-4">2026</p>
              <p className="text-xl text-gray-300 leading-relaxed">
                一人ひとりの世界観・キャラクター性・目標に合わせ、あなた自身の活動スタイルを一緒に作っていきます。VTuberは"数字だけ"でなく、"物語と継続"が大切。私たちは、あなたの活動に本気で向き合います。
              </p>
            </div>

            <div className="grid grid-cols-2 gap-6">
              <div className="bg-white/5 backdrop-blur-sm rounded-2xl p-6 border border-white/10">
                <p className="text-4xl font-bold text-pink-400 mb-2">10+</p>
                <p className="text-sm text-gray-300">所属タレント</p>
              </div>
              <div className="bg-white/5 backdrop-blur-sm rounded-2xl p-6 border border-white/10">
                <p className="text-4xl font-bold text-cyan-400 mb-2"></p>
                <p className="text-sm text-gray-300">総登録者数</p>
              </div>
              <div className="bg-white/5 backdrop-blur-sm rounded-2xl p-6 border border-white/10">
                <p className="text-4xl font-bold text-pink-400 mb-2">100+</p>
                <p className="text-sm text-gray-300">コラボ実績</p>
              </div>
              <div className="bg-white/5 backdrop-blur-sm rounded-2xl p-6 border border-white/10">
                <p className="text-4xl font-bold text-cyan-400 mb-2">50+</p>
                <p className="text-sm text-gray-300">ライブイベント</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}